import setCurrentPage from "src/Utils/setCurrentPage";
import ConversationEffect from "src/Animations/ConversationEffect";

export const DATA_ND_DEMO_TCA_2 = {
  title: "Streamlining operations\n with a single pane of glass",
  subtitle: "Network designer",
  text: "Gain instant insights into your entire network infrastructure.\n Explore a comprehensive overview of all network service\n instances across various lines of business, seamlessly integrated\n with our onboarded service/NF templates. Uncover a unified\n perspective that empowers you to manage your network\n resources with unparalleled efficiency.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_308"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => {
      setCurrentPage("ILO_306");
    },
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/TCA/TCA_Demo_bg.jpg",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ILO/TCA/TCA_ND_Demo_2_Screen_1.png",
          imageStyle: { alignSelf: "flex-end", marginTop: "107px" },
        },
        {
          image: "ILO/TCA/TCA_ND_Demo_2_Screen_2.png",
          imageStyle: { position: "absolute", left: "876px", bottom: "70px" },
        },
      ]}
      conversationStyle={{ width: "auto" }}
      pageNumber={"ILO_307"}
    />
  ),
};
